export default __webpack_public_path__ + "static/media/stkq.ee32b942.png";